<dx-button *ngIf="dataGrid" icon="clearformat" hint="Réinitialiser les personnalisations d'affichage de la grille" (onClick)="onStateResetClick()"></dx-button>